<template>
  <b-modal ref="modal" hide-footer title="Recieve Transfer">
    <b-row class="my-1">
      <b-col md="4">
        <label for="statuses">Transfer Code</label>
      </b-col>
      <b-col md="5">
        <b-form-input v-model="transferCode"></b-form-input>
      </b-col>
      <b-col md="3">
        <b-button
          variant="success"
          block
          @click="findTransfer"
          :disabled="transferCode == ''"
        >
          Find
        </b-button>
      </b-col>
    </b-row>

    <Feedback ref="saveFeedback" />

    <b-row class="my-1" v-if="company">
      <b-col md="4">
        <label for="statuses">Company Name</label>
      </b-col>
      <b-col md="8">
        {{ company.companyName }}
      </b-col>
    </b-row>

    <b-row class="my-1" v-if="company">
      <b-col md="4">
        <label for="statuses">Current Owner</label>
      </b-col>
      <b-col md="8" v-if="company.lockedUser">
        {{ company.lockedUser.firstName + " " + company.lockedUser.lastName }}
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4"> </b-col>
      <b-col md="4">
        <b-button class="mt-3" variant="danger" block @click="hideModal">
          <font-awesome-icon icon="times" /> Cancel
        </b-button>
      </b-col>
      <b-col md="4">
        <b-button
          class="mt-3"
          variant="success"
          block
          @click="completeTransfer"
          :disabled="company == null"
        >
          <font-awesome-icon icon="phone" /> Recieve
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import CompanyService from "@/services/Company.service";
import Feedback from "@/components/shared/Feedback.vue";
import router from "@/router";

export default {
  components: { Feedback },
  data() {
    return {
      transferCode: "",
      company: null,
    };
  },
  methods: {
    showModal() {
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },
    findTransfer() {
      CompanyService.findTransfer(this.transferCode)
        .then((response) => {
          this.company = response.data;
          this.$refs.saveFeedback.clear();
        })
        .catch((error) => {
          this.$refs.saveFeedback.showError("Error", error.data);
        });
    },

    completeTransfer() {
      CompanyService.completeTransfer(this.company.id)
        .then(() => {
          router.push(`/company/${this.company.id}`);
        })
        .catch((error) => {
          this.$refs.saveFeedback.showError("Error", error.data);
        });
    },
  },
};
</script>
